/*
 * @Author       : Tom
 * @Date         : 2019-12-16 10:19:24
 * @LastEditors  : Tom
 * @LastEditTime : 2019-12-21 21:59:53
 * @FilePath     : /shop_front_end/src/main.js
 * @Description  : 入口
 */

import Vue from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import 'ant-design-vue/dist/antd.css'
import request from './lib/request'


import $ from 'jquery'

import {exportURL} from './lib/config.js'

import validator from 'validator';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)


Vue.use(Viewer)

Vue.config.productionTip = false

Vue.use(Antd)



// 确认弹框用antdv


Vue.prototype.$validator = validator
Vue.prototype.exportURL = exportURL


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
